import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTrafficFlowApiMeta } from "../apiMeta";
import {
  type TrafficFlowsInput,
  trafficFlowsInputSchema,
} from "./shared/flowData.input";
import { type FlowData, flowDataSchema } from "./shared/flowData.output";

/**
 * Metadata for the fetchTrafficFlows endpoint
 */
export const trafficFlowsMeta = {
  functionName: "fetchTrafficFlows",
  endpoint: "/getTrafficFlowsAsJson",
  inputSchema: trafficFlowsInputSchema,
  outputSchema: flowDataSchema.array(),
  sampleParams: {},
  endpointDescription:
    "List current traffic flow conditions for all stations statewide.",
} satisfies EndpointMeta<TrafficFlowsInput, FlowData[]>;

/**
 * Fetch function for retrieving current traffic flow conditions for all stations statewide
 */
const { fetch, useHook } = createFetchAndHook<TrafficFlowsInput, FlowData[]>({
  api: wsdotTrafficFlowApiMeta,
  endpoint: trafficFlowsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/flowData.endpoints").flowDataGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving current traffic flow conditions for all stations statewide
 */
export const fetchTrafficFlows: FetchFactory<TrafficFlowsInput, FlowData[]> =
  fetch;

/**
 * React Query hook for retrieving current traffic flow conditions for all stations statewide
 */
export const useTrafficFlows: HookFactory<TrafficFlowsInput, FlowData[]> =
  useHook;
